// redux/actions/businessExpenseActions.js
import axios from 'axios';
import BASE_URL from '../../utils/apiConfig';

// Tipos de acciones
export const FETCH_EXPENSES_REQUEST = 'FETCH_EXPENSES_REQUEST';
export const FETCH_EXPENSES_SUCCESS = 'FETCH_EXPENSES_SUCCESS';
export const FETCH_EXPENSES_FAILURE = 'FETCH_EXPENSES_FAILURE';

export const FETCH_EXPENSE_SUMMARY_REQUEST = 'FETCH_EXPENSE_SUMMARY_REQUEST';
export const FETCH_EXPENSE_SUMMARY_SUCCESS = 'FETCH_EXPENSE_SUMMARY_SUCCESS';
export const FETCH_EXPENSE_SUMMARY_FAILURE = 'FETCH_EXPENSE_SUMMARY_FAILURE';

export const CREATE_EXPENSE_REQUEST = 'CREATE_EXPENSE_REQUEST';
export const CREATE_EXPENSE_SUCCESS = 'CREATE_EXPENSE_SUCCESS';
export const CREATE_EXPENSE_FAILURE = 'CREATE_EXPENSE_FAILURE';

export const UPDATE_EXPENSE_REQUEST = 'UPDATE_EXPENSE_REQUEST';
export const UPDATE_EXPENSE_SUCCESS = 'UPDATE_EXPENSE_SUCCESS';
export const UPDATE_EXPENSE_FAILURE = 'UPDATE_EXPENSE_FAILURE';

export const DELETE_EXPENSE_REQUEST = 'DELETE_EXPENSE_REQUEST';
export const DELETE_EXPENSE_SUCCESS = 'DELETE_EXPENSE_SUCCESS';
export const DELETE_EXPENSE_FAILURE = 'DELETE_EXPENSE_FAILURE';

export const SET_EXPENSE_FILTER = 'SET_EXPENSE_FILTER';
export const RESET_EXPENSE_FILTER = 'RESET_EXPENSE_FILTER';

// Action creators

// Obtener todos los gastos
export const fetchExpenses = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_EXPENSES_REQUEST });
  
  try {
    // Construir string de consulta para filtros
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });
    
    const response = await axios.get(`${BASE_URL}/expenses?${queryParams.toString()}`);
    
    dispatch({
      type: FETCH_EXPENSES_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_EXPENSES_FAILURE,
      payload: error.response?.data?.error || 'Error al obtener gastos'
    });
    throw error;
  }
};

// Obtener resumen de gastos
export const fetchExpenseSummary = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_EXPENSE_SUMMARY_REQUEST });
  
  try {
    // Construir string de consulta para filtros
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });
    
    const response = await axios.get(`${BASE_URL}/expenses/summary?${queryParams.toString()}`);
    
    dispatch({
      type: FETCH_EXPENSE_SUMMARY_SUCCESS,
      payload: response.data.data
    });
    
    return response.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_EXPENSE_SUMMARY_FAILURE,
      payload: error.response?.data?.error || 'Error al obtener resumen de gastos'
    });
    throw error;
  }
};

// Crear un nuevo gasto
export const createExpense = (expenseData) => async (dispatch) => {
  dispatch({ type: CREATE_EXPENSE_REQUEST });
  
  try {
    const response = await axios.post(`${BASE_URL}/expenses`, expenseData);
    
    dispatch({
      type: CREATE_EXPENSE_SUCCESS,
      payload: response.data.data
    });
    
    return response.data.data;
  } catch (error) {
    dispatch({
      type: CREATE_EXPENSE_FAILURE,
      payload: error.response?.data?.error || 'Error al crear gasto'
    });
    throw error;
  }
};

// Actualizar un gasto existente
export const updateExpense = (id, expenseData) => async (dispatch) => {
  dispatch({ type: UPDATE_EXPENSE_REQUEST });
  
  try {
    const response = await axios.put(`${BASE_URL}/expenses/${id}`, expenseData);
    
    dispatch({
      type: UPDATE_EXPENSE_SUCCESS,
      payload: response.data.data
    });
    
    return response.data.data;
  } catch (error) {
    dispatch({
      type: UPDATE_EXPENSE_FAILURE,
      payload: error.response?.data?.error || 'Error al actualizar gasto'
    });
    throw error;
  }
};

// Eliminar un gasto
export const deleteExpense = (id) => async (dispatch) => {
  dispatch({ type: DELETE_EXPENSE_REQUEST });
  
  try {
    await axios.delete(`${BASE_URL}/expenses/${id}`);
    
    dispatch({
      type: DELETE_EXPENSE_SUCCESS,
      payload: id
    });
    
    return true;
  } catch (error) {
    dispatch({
      type: DELETE_EXPENSE_FAILURE,
      payload: error.response?.data?.error || 'Error al eliminar gasto'
    });
    throw error;
  }
};

// Establecer filtros de gastos
export const setExpenseFilter = (filters) => ({
  type: SET_EXPENSE_FILTER,
  payload: filters
});

// Restablecer filtros de gastos
export const resetExpenseFilter = () => ({
  type: RESET_EXPENSE_FILTER
});